import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import useServicios from "../../hooks/useServicios";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import HomeSplash from "../../components/HomeSplash";


const normalizarCategoria = (t) => {
  if (!t) return "";
  return t
    .replace(/sesiones de /i, "")
    .replace(/plan(es)? de /i, "")
    .trim();
};

// Evita que la tarjeta haga auto-scroll al abrir un menú
const mantenerScroll = () => {
  const y = window.scrollY;
  requestAnimationFrame(() => window.scrollTo(0, y));
};

const Servicios = () => {
  const { servicios, loading } = useServicios();
  const [menuActivo, setMenuActivo] = useState(null);
  const [periodoActivo, setPeriodoActivo] = useState(null);
  const [cfgPareja, setCfgPareja] = useState(null);

  const menuRefs = useRef([]);
  const navigate = useNavigate();

  const [navH, setNavH] = useState(80); // fallback

    useEffect(() => {
      const medir = () => {
        // intenta encontrar el navbar (ajusta selector si tu navbar usa otro tag/clase)
        const el =
          document.querySelector("nav") ||
          document.querySelector("header") ||
          document.querySelector("#navbar") ||
          document.querySelector("[data-navbar]");

        if (!el) return;
        const h = Math.round(el.getBoundingClientRect().height || 0);
        if (h > 0) setNavH(h);
      };

      medir();
      window.addEventListener("resize", medir);
      return () => window.removeEventListener("resize", medir);
    }, []);


  // ================================
  // Cargar configuración de descuentos
  // ================================
  useEffect(() => {
    async function cargarCfg() {
      try {
        const ref = doc(db, "config", "pareja_precios");
        const snap = await getDoc(ref);
        if (snap.exists()) setCfgPareja(snap.data());
      } catch (e) {
        console.error("Error cargando pareja_precios:", e);
      }
    }
    cargarCfg();
  }, []);

  // ================================
  // Generar variantes con descuento
  // ================================
  const generarVariantesPareja = (variantesBase) => {
    if (!Array.isArray(variantesBase)) return [];

    const globalDesc = cfgPareja?.descuento_global ?? 20;
    const descPorNivel = cfgPareja?.descuentos_por_nivel ?? {};

    return variantesBase.map((v) => {
      const precioBase = Number(v.precio || 0);
      const nivel = v.nivel || "";
      const desc = descPorNivel[nivel] ?? globalDesc;

      const factor = 1 - desc / 100;
      const precioFinal = Math.round(precioBase * 2 * factor);

      return {
        ...v,
        nombre: `${v.nombre} (pareja)`,
        precio: precioFinal,
      };
    });
  };

  // REFERENCIAS DE MENÚS
  // REFERENCIAS DE MENÚS — se genera una ref por cada servicio cargado
  useEffect(() => {
    menuRefs.current = servicios.map((_, i) => menuRefs.current[i] || React.createRef());
  }, [servicios]);


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (menuActivo !== null) {
        const activeRef = menuRefs.current[menuActivo];
        if (activeRef?.current && !activeRef.current.contains(e.target)) {
          setMenuActivo(null);
          setPeriodoActivo(null);
        }
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [menuActivo]);

  if (loading || !cfgPareja) {
    return <HomeSplash show topOffset={navH} zIndex={40} />;
  }

  // ==========================================================
  // TARJETA
  // ==========================================================
  const Tarjeta = ({ servicio, index }) => {
    let variantes = servicio.variantes;
    let isNested =
      variantes &&
      typeof variantes === "object" &&
      !Array.isArray(variantes);

    // ===========================
    // 🔥 SI ES ENTRENAMIENTO EN PAREJA → GENERAR VARIANTES
    // ===========================
if (servicio.id?.toLowerCase() === "pareja") {
// Caso especial: servicio "pareja" siempre usa variantes nested
if (Array.isArray(variantes)) {
  const obj = {};

  variantes.forEach(v => {
    // Extraer período desde el nombre: (mensual), (trimestral), (semestral)
let periodoDetectado = "Mensual";

const nombreLower = (v.nombre || "").toLowerCase();

if (nombreLower.includes("trimestral")) periodoDetectado = "Trimestral";
else if (nombreLower.includes("semestral")) periodoDetectado = "Semestral";
else if (nombreLower.includes("mensual")) periodoDetectado = "Mensual";

const periodo = periodoDetectado;
  // si falta, default
    if (!obj[periodo]) obj[periodo] = [];
    obj[periodo].push(v);
  });

  variantes = obj;
}

isNested = true;



    }

    // =======================================
// 🔵 Caso especial: KINESIOLOGÍA
// Agrupar variantes según (Isapre) / (Fonasa)
// =======================================
if (servicio.id?.toLowerCase() === "kinesiologia") {
  if (Array.isArray(variantes)) {
    const obj = {};

    variantes.forEach((v) => {
      const nombreLower = (v.nombre || "").toLowerCase();
      let grupo = "Isapre"; // default

      if (nombreLower.includes("fonasa")) grupo = "Fonasa";
      else if (nombreLower.includes("isapre")) grupo = "Isapre";

      if (!obj[grupo]) obj[grupo] = [];
      obj[grupo].push(v);
    });

    variantes = obj; // ahora son nested
  }

  isNested = true;
}


let esArray = Array.isArray(variantes);
isNested = !esArray && typeof variantes === "object" && variantes !== null;




    return (
      <div
        className="
          w-full max-w-[800px]
          bg-white/60 backdrop-blur-xl 
          shadow-[0_18px_50px_-15px_rgba(58,106,255,0.25)]
          ring-1 ring-white/30
          rounded-3xl 
          overflow-hidden
          transition-all
        "
      >
        <div className="flex flex-col sm:flex-row">

          {/* FOTO */}
            <div className="sm:w-1/2 w-full overflow-hidden flex">
              <img
                src={servicio.image}
                alt={servicio.title}
                className="
                  w-full 
                  h-full              /* se estira con la tarjeta */
                  min-h-[260px]       /* altura base en móvil */
                  sm:min-h-[300px]    /* altura base en desktop */
                  object-cover 
                  rounded-t-3xl 
                  sm:rounded-l-3xl 
                  sm:rounded-tr-none
                "
              />
            </div>

          {/* CONTENIDO */}
          <div className="p-6 sm:w-1/2 flex flex-col justify-between text-sm">

            <div>
              <h2 className="text-2xl font-bold text-[#0A1440] mb-2">
                {servicio.title}
              </h2>

              <p className="text-gray-700 whitespace-pre-line leading-relaxed mb-2">
                {servicio.desc}
              </p>

              {servicio.extra && (
                <span className="text-[#00698F] font-semibold text-sm">
                  {servicio.extra}
                </span>
              )}
            </div>

            {/* MENÚ DE RESERVA */}
            <div className="mt-4 flex flex-col gap-2" ref={menuRefs.current[index]}>

              {/* INACTIVO */}
              {!servicio.activo ? (
                <button
                  disabled
                  className="bg-gray-300 text-gray-600 py-2 px-4 rounded-xl cursor-not-allowed"
                >
                  Próximamente
                </button>
                  ) : (Array.isArray(variantes)) ? (
                    <>
                      <button
                        onClick={() => {
                          mantenerScroll();
                          setPeriodoActivo(null);
                          setMenuActivo(menuActivo === index ? null : index);
                        }}
                        className="bg-[#00698F] hover:bg-[#06b6fa] text-white py-2 px-4 rounded-xl transition"
                      >
                        Reservar
                      </button>

                      {menuActivo === index && (
                        <div className="bg-white border border-gray-200 rounded-xl shadow-lg">
                          {variantes.map((op, i) => (
                            <button
                              key={i}
                              onClick={() => {
                                localStorage.setItem(
                                  "servicioSeleccionado",
                                  JSON.stringify({
                                    categoria: normalizarCategoria(servicio.title),
                                    variante: servicio.id?.toLowerCase() === "kinesiologia"
                                      ? op.nombre.split(":")[0].trim()
                                      : op.nombre,
                                    id: op.id || null,
                                    precio: op.precio,
                                  })
                                );
                                localStorage.setItem("flujoReserva", "servicio");
                                navigate("/agenda");
                              }}
                              className="w-full text-left px-4 py-3 text-sm text-gray-800 hover:bg-blue-100 transition"
                            >
                              {
                                servicio.id?.toLowerCase() === "kinesiologia"
                                  ? op.nombre
                                  : `${op.nombre}: $${op.precio.toLocaleString("es-CL")}`
                              }
                            </button>
                          ))}
                        </div>
                      )}
                    </>

              ) : isNested ? (
                <>
                  <button
                    onClick={() => {
                      mantenerScroll();
                      const shouldClose = menuActivo === index;
                      setMenuActivo(shouldClose ? null : index);
                      setPeriodoActivo(null);
                    }}
                    className="bg-[#00698F] hover:bg-[#06b6fa] text-white py-2 px-4 rounded-xl transition"
                  >
                    Reservar
                  </button>

                  {menuActivo === index && (
                    <div className="bg-white border border-gray-200 rounded-xl shadow-lg">
                      {periodoActivo === null ? (
                        Object.keys(variantes).map((nivel) => (
                          <button
                            key={nivel}
                            onClick={() => {
                              mantenerScroll();
                              setPeriodoActivo(nivel);
                            }}
                            className="w-full text-left px-4 py-3 text-sm font-semibold text-blue-600 hover:bg-blue-50 transition"
                          >
                            {nivel}
                          </button>
                        ))
                      ) : (
                        <>
                          <div className="border-b px-4 py-3 text-sm font-bold text-blue-600 bg-blue-50">
                            {periodoActivo}
                          </div>

                          {variantes[periodoActivo].map((op, i) => (
                            <button
                              key={i}
                              onClick={() => {
                                localStorage.setItem(
                                  "servicioSeleccionado",
                                  JSON.stringify({
                                    categoria: normalizarCategoria(servicio.title),
                                    variante: servicio.id?.toLowerCase() === "kinesiologia"
                                      ? op.nombre.split(":")[0].trim()
                                      : op.nombre,
                                    id: op.id || null,
                                    precio: op.precio,
                                  })
                                );
                                localStorage.setItem("flujoReserva", "servicio");
                                navigate("/agenda");
                              }}
                              className="w-full text-left px-6 py-3 text-sm text-gray-800 hover:bg-blue-100 transition"
                            >
                              {servicio.id?.toLowerCase() === "kinesiologia"
                                ? op.nombre
                                : `${op.nombre}: $${op.precio.toLocaleString("es-CL")}`}
                            </button>
                          ))}
                        </>
                      )}
                    </div>
                  )}
                </>
              ) : (
                <button
                  onClick={() => {
                    localStorage.setItem(
                      "servicioSeleccionado",
                      JSON.stringify({
                        categoria: normalizarCategoria(servicio.title),
                        variante: "Promoción única",
                        id: null,
                        precio: servicio.precio_unico || 25000,
                      })
                    );
                    localStorage.setItem("flujoReserva", "servicio");
                    navigate("/agenda");
                  }}
                  className="bg-[#00698F] hover:bg-[#06b6fa] text-white py-2 px-4 rounded-xl transition"
                >
                  Reservar
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // ==========================================================
  // DISTRIBUIR TARJETAS EN COLUMNAS
  // ==========================================================
  const leftColumn = servicios.filter((_, i) => i % 2 === 0);
  const rightColumn = servicios.filter((_, i) => i % 2 !== 0);

  return (
    <div className="min-h-screen py-12 px-4 sm:px-6 md:px-12 lg:px-20 bg-[#E5E5E5]">

      <h1 className="text-4xl font-extrabold text-center text-[#0A1440] mb-12">
        Nuestros <span className="text-[#00698F]">Servicios</span>
      </h1>

      <div className="flex flex-col lg:flex-row justify-center gap-x-12 max-w-7xl mx-auto">
        <div className="flex flex-col items-center gap-y-12 w-full lg:w-1/2">
          {leftColumn.map((s, i) => {
            const originalIndex = i * 2;
            return <Tarjeta key={originalIndex} servicio={s} index={originalIndex} />;
          })}
        </div>

        <div className="flex flex-col items-center gap-y-12 mt-20 lg:mt-10 w-full lg:w-1/2">
          {rightColumn.map((s, i) => {
            const originalIndex = i * 2 + 1;
            return <Tarjeta key={originalIndex} servicio={s} index={originalIndex} />;
          })}
        </div>
      </div>
    </div>
  );
};

export default Servicios;
